import { ConfirmDeleteTarget } from "models/ConfirmDeleteTarget";
import { TaskModel } from "models/TaskModel";
import { createContext } from "react";

export interface TaskContextProps {
  tasks: TaskModel[];
  selectTaskId: number;
  setSelectTaskId: (id: number) => void;
  confirmDeleteTask: ConfirmDeleteTarget | undefined;
  setConfirmDeleteTask: (target: ConfirmDeleteTarget | undefined) => void;
  isTaskDeleting: (id: number) => boolean;
  setTaskDeleting: (id: number, newState: boolean) => void;
  isTaskUpdating: (id: number) => boolean;
  setTaskUpdating: (id: number, newState: boolean) => void;
}

export const TaskContext = createContext({} as TaskContextProps);
